import React, { useState } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import { Loader } from "@egovernments/digit-ui-react-components";
// import { Button } from "react-bootstrap";
import InputWrapper from "../../citizen/AVPForms/layout/inputWrapper";
import { IconButton, Table, TableContainer } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import { Button, Tab } from "react-bootstrap";
import { all } from "axios";
import CompoundingTable from "./PaymentHeadCompounding";
import { useHistory } from "react-router-dom";


const PaymentHead = ({
  tenantId,
  formData,
  setTaxHead,
  taxHead,
  empRole,
  isFeesEligible,
  Modal,
  onSelect,
  isValidEmp,
  setShowCurrentChallan = () => {},
  isFromDashboard,
}) => {
  const { data, isLoading: isDataLoading } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["MapSubPaymentHeads"]);
  const [moreHeads, setMoreHeads] = useState([]);
  const history = useHistory(); 
  const [allRemarks, setAllRemarks] = useState({});
  // const [showCalculateButton, setShowCalculateButton] = useState(false);
  // const tenantId = Digit.ULBService.getCurrentTenantId();
  const isSelfApproval =
    formData?.planOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" ||
    formData?.planOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm" ||
    formData?.planOn === "SELF_MAP";
  const isCompounding = formData?.natureOfConstruction === "Compounding";
  const isApprovedMapSubmission = formData?.mapSubmissionStatus === "APPROVED";
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId);
  // const mapSubFeesTwo = formData?.taxHeadEstimates?.filter((item) => item.taxHeadCode === "BPA_MAP_SUBMISSION_FEE_2")?.[0]?.paymentHeads || {};
  // const mabSubComp = formData?.taxHeadEstimates?.filter((item) => item.taxHeadCode === "BPA_MAP_SUBMISSION_FEE")?.[0]?.compoundingHeads || {};
  // console.log("mapSubFeesTwo", mapSubFeesTwo, formData, mabSubComp);
  const isResidential = formData?.primaryUse === "Residential";
  const isCommercial = formData?.primaryUse === "Commercial";
  const isOffice = formData?.primaryUse === "Office";
  const isIndustrial = formData?.primaryUse === "Industrial";
  const isFacilities = formData?.primaryUse === "Facilities/Other";
  const activeCategory = isResidential
    ? "Residential"
    : isCommercial
    ? "Commercial"
    : isOffice
    ? "Office"
    : isIndustrial
    ? "Industrial"
    : isFacilities
    ? "Facilities/Other"
    : null;

  const [disabled, setDisabled] = useState(false);

  const handleNoWorkflow = (taxHeadData, compoundingHeads) => {
    // console.log("handleNoWorkflow invoked", { taxHeadData, compoundingHeads, isValidEmp });
    // if (!isValidEmp) {
    //   Modal("Invalid Action", "You are not authorized to take action on this application.", "error");
    //   return;
    // }
    // console.log("insideHandleNoWorkflow", taxHeadData);

    const calculatedCompoundingHeads = taxHeadData?.[0]?.compoundingHeads || [];

    const workflow = {
      action: "NOWORKFLOW",
      comments: "",
    };
    const appData = {
      ...formData,
      workflow,

      // taxHeadEstimates: [...formData?.taxHeadEstimates, ...taxHeadData] || [],
      taxHeadEstimates: [...taxHeadData] || [],
      compoundingHeads: calculatedCompoundingHeads,
      // inspectionDetailData:
      //     userRolesArray?.[0]?.code === "JE"
      //         ? data
      //         : formData?.inspectionDetailData,
    };
    updateApiCall.mutate(
      { BPA: appData },
      {
        onSuccess: (result) => {
          // console.log("resultFromUpdate", result);
          onSelect(result?.BPA?.[0]);
          // const isPaymenthead = taxHeadData?.some((item) => item.calculationBusinesserviceId == "BPA.MAP_SUBMISSION_FORM_FEE");

          // Modal(`Application updated.`, `Application Updated Successfully!`, "success", "/digit-ui/employee");
          // Digit?.SessionStorage.set("isPaymenthead", isPaymenthead);
          // Modal(`Payment head updated`, `Payment heads for <strong>(${formData?.applicationNo})</strong> updated successfully!`, "success");
        },
      }
    );
    history.replace(
                        window.location.pathname + window.location.search
                    );
  };

  setShowCurrentChallan(true);
  const authToken = Digit.UserService.getUser()?.access_token || null;
  // const isShortfall =
  //   allRemarks?.SecurityReport?.[0]?.detailDataRemarks?.[0]?.documentDetails?.dataRecommendation === "Shortfall" ||
  //   allRemarks?.SecurityReport?.[0]?.detailDataRemarks?.[0]?.drawingsDetails?.dataRecommendation === "Shortfall" ||
  //   allRemarks?.SecurityReport?.[0]?.detailDataRemarks?.[0]?.inspectionDetails?.dataRecommendation === "Shortfall";
  // const handleGetNotingById = async (applicationNumber) => {
  //   console.log("Inside handleGetNotingById", applicationNumber, authToken);
  //   const dataToSend = {
  //     RequestInfo: {
  //       apiId: "Rainmaker",
  //       action: "_create",
  //       did: 1,
  //       key: "",
  //       msgId: "20170310130900|en_IN",
  //       ts: 0,
  //       ver: ".01",
  //       authToken: authToken,
  //     },
  //   };
  //   try {
  //     const response = await axios.post(`${Urls.bpaService.remarksNoting}applicationNo=${applicationNumber}`, dataToSend);
  //     const Resp = response.data;
  //     console.log("responsefromPayment", Resp);
  //     setAllRemarks(Resp);
  //   } catch (error) {
  //     console.error("❌ Error in handleGetNotingById", error?.message || error);
  //   }
  // };
  const isDA = formData?.department === "DA";
  const sessionData = JSON.parse(sessionStorage.getItem("paymentHeads"));
  const isJE = empRole === "JE";

  const calculateRate = (plotArea, ranges) => {
    // console.log("rangesFromCalculate", ranges, plotArea);

    for (const range of ranges) {
      if (range.area.includes("-")) {
        const [min, max] = range.area.split("-").map(Number);
        if (plotArea >= min && plotArea <= max) {
          return range.rate;
        }
      } else if (range.area.endsWith("+")) {
        const base = parseInt(range.area);
        if (plotArea > base) {
          const additional = plotArea - base;
          const blocks = Math.ceil(additional / 1000);
          return (ranges.find((r) => r.area === "501-1000")?.rate || 0) + blocks * range.ratePerAdditional1000;
        }
      }
    }
    return 0; // default if no match
  };

  const [paymentHead, setPaymentHead] = useState(formData?.taxHeadEstimates?.[1]?.paymentHeads || []);
  const [compoundingHead, setCompoundingHead] = useState(formData?.taxHeadEstimates?.[0]?.compoundingHeads || []);
  const mdmsPaymentHeads = data?.BPA?.MapSubPaymentHeads;

  // console.log(paymentHead, compoundingHead, "compoundingData");

  // MDMS call for Compounding Fee Heads
  const { data: compoundingData, isLoading: isCompoundingLoading } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["CompoundingFeeHeads"]);

  const compoundingFeeHeads = compoundingData?.BPA?.CompoundingFeeHeads || [];

  // console.log("compoundingFeeHeads", compoundingFeeHeads);
  // Modal state
  const [openCompoundingModal, setOpenCompoundingModal] = useState(false);

  const onClickCompoundingButton = () => {
    setOpenCompoundingModal(true);
  };

 
  const defaultValues = {
    paymentHeads: [{ feeType: "", plotBuildUpArea: "", rate: "", amount: "" }], // Default row
  };
  // console.log("taxHeadValue", mdmsPaymentHeads, formData);

  // Initializing useForm
  const { control, handleSubmit, watch, reset, setValue } = useForm({ defaultValues });

  const { fields: additionalHeads, append, remove } = useFieldArray({
    control,
    name: "additionalHeads", // This is the name for the dynamic rows array
  });

  const onSubmit = async (payload) => {
    if (isJE) {
      if (isSelfApproval && !["APPROVED_JE"].includes(formData?.status)) {
        Modal("Unauthorized Action", "This action is prohibited.", "error");
        return;
      }
    }
    setDisabled(true);
    const checkedKeys = Object.entries(payload)
      .filter(([_, value]) => value.checked === true)
      .map(([key, value]) => ({
        feeType: key,
        plotBuildUpArea: value.plotBuildUpArea,
        updatedAreaJE: value.updatedAreaJE,
        rate: value.rate,
        amount: "", // or calculate if needed
        remarks: value.remarks || "", // or calculate if needed
      }));
    // const paymentHeads = payload
    // console.log("checkedKeys", checkedKeys);

    const finalPayload = {
      ...formData,
      paymentHeads: payload?.additionalHeads?.length > 0 ? [...checkedKeys, ...payload?.additionalHeads] : checkedKeys,
    };
    if (payload?.additionalHeads?.length > 0) {
      setMoreHeads(payload?.additionalHeads);
    }
    // console.log("Payload After Processing", finalPayload);
    const CalulationCriteria = [{ BPA: finalPayload, tenantId: "up", feeType: "ApplicationFee" }];
    const data = await Digit.OBPSService.bpacalculatechallan({ CalulationCriteria });
    // console.log("loggingCalculatedata", data);

    if (data?.Calculations?.[0]?.errorMessage == null) {
      // console.log("bpacalculatechallan success", data);
      sessionStorage.setItem("paymentHeads", JSON.stringify(data?.Calculations?.[0]?.taxHeadEstimates?.[0]?.paymentHeads));
      const sessionData = JSON.parse(sessionStorage.getItem("paymentHeads"));
      // console.log("sessionFromSubmit", sessionData);
      // const paidChallan = formData?.taxHeadEstimates?.find((item) => item.paymentStatus === "PAID") || {} ;
      const paidChallan = formData?.taxHeadEstimates?.find(
  (item) => item.paymentStatus === "PAID"
);
      setTaxHead(data?.Calculations?.[0]?.taxHeadEstimates);
      setPaymentHead(data?.Calculations?.[0].taxHeadEstimates?.[0]?.paymentHeads || []);
      // console.log("fromSubmitPaymentHead", data?.Calculations?.[0]?.taxHeadEstimates, data?.Calculations?.[0]?.taxHeadEstimates?.[0]?.paymentHeads);
      // const workflowTaxHeadData = data?.Calculations?.[0]?.taxHeadEstimates || [];
      const workflowTaxHeadData = [
  ...(data?.Calculations?.[0]?.taxHeadEstimates || []),
  ...(paidChallan ? [paidChallan] : []),
];

      
      // console.log("call handleNoWorkflow with", workflowTaxHeadData ,data?.Calculations?.[0]?.taxHeadEstimates ,paidChallan);
      await handleNoWorkflow(workflowTaxHeadData, []);
      const modalMsg = isSelfApproval ? "Please take Revise Payment action from take action tab." : "Payment heads updated successfully.";
      Modal("Payment heads updated successfully", modalMsg, "success");
    } else {
      Modal("Error", data?.Calculations?.[0]?.errorMessage, "error");
    }
    setDisabled(false);

    // // console.log("loggingAdditionalFieldsfromSubmit", additionalHeads);
  };

  // useEffect(() => {
  //   const sessionData = JSON.parse(sessionStorage.getItem("paymentHeads"));
  //   console.log("fromEffectsessionOutsideIf", sessionData);

  //   if (sessionData) {
  //     console.log("fromEffectsessionInsideIf", sessionData);
  //     // Parse the saved data

  //     // Set the default values for the dynamic form fields
  //     reset({ paymentHeads: sessionData });
  //   }
  // }, []);
  // useEffect(() => {
  //   console.log("insidefirsteffect", formData?.applicationNo);

  //   if (formData?.applicationNo) {
  //     handleGetNotingById(formData?.applicationNo);
  //   }
  // }, [formData?.applicationNo]);
  // useEffect(() => {
  //   // Only show the button if NOT shortfall and allRemarks is loaded
  //   const isShortfall =
  //     allRemarks?.SecurityReport?.[0]?.detailDataRemarks?.[0]?.documentDetails?.dataRecommendation === "Shortfall" ||
  //     allRemarks?.SecurityReport?.[0]?.detailDataRemarks?.[0]?.drawingsDetails?.dataRecommendation === "Shortfall" ||
  //     allRemarks?.SecurityReport?.[0]?.detailDataRemarks?.[0]?.inspectionDetails?.dataRecommendation === "Shortfall";
  //   console.log("fromsecondEffect", allRemarks, !isShortfall);

  //   setShowCalculateButton(allRemarks && !isShortfall);
  // }, [allRemarks]);
  const handleAddInput = () => {
    append({ feeType: "", plotBuildUpArea: "", rate: "" });
  };

  if (isDataLoading) {
    return <Loader />;
  }

  const handleCompoundingSubmit = async (compoundingHeads) => {
    setDisabled(true);

    // console.log("compoudingHeads",compoundingHeads);
    
    const finalPayload = {
      ...formData,

      // ✅ send separately (for storage/use)
      compoundingHeads: compoundingHeads,

      // ✅ MUST send inside taxHeadEstimates for calculation engine
      taxHeadEstimates: [
        {
          calculationBusinesserviceId: "BPA.MAP_SUBMISSION_FORM_FEE",
          compoundingHeads: compoundingHeads,
        },
      ],
    };

    const CalulationCriteria = [
      {
        BPA: finalPayload,
        tenantId,
        feeType: "ApplicationFee",
      },
    ];

    try {
      const data = await Digit.OBPSService.bpacalculatechallan({
        CalulationCriteria,
      });

      // if (data?.Calculations?.[0]?.errorMessage) {
      //   Modal("Error", data.Calculations[0].errorMessage, "error");
      //   return;
      // }

      // console.log("compoundingHead", compoundingHeads);
      setTaxHead(data.Calculations[0].taxHeadEstimates);
      setCompoundingHead(data.Calculations[0].taxHeadEstimates?.[0]?.compoundingHeads);

      // ✅ SAME update API
      handleNoWorkflow(data.Calculations[0].taxHeadEstimates);

      Modal("Success", "Compounding fees calculated successfully", "success");
   
    } catch (err) {
      Modal("Error", "Something went wrong", "error");
    } finally {
      setDisabled(false);
    }
  };

  return (
    <React.Fragment>
   {formData?.natureOfConstruction != "Compounding" ? (
  <form onSubmit={handleSubmit(onSubmit)}>
        {!isApprovedMapSubmission && (
          <TableContainer className="table-container">
            <Table stickyHeader className="application-table">
              {/* {!isJE && isDA && (
          <div style={{ marginBottom: "4px" }}>
            <NewsTicker textForNews={"Below details are filled by Junior Engineer!"} time={"42"} fontSize={"13px"} />
          </div>
        )} */}
              {/* <Table bordered hover responsive className="formHeaderContainer"> */}
              <thead>
                <tr>
                  <th className="fit-table-head">Select</th>
                  <th className="fit-table-head">Payment Heads</th>
                  <th className="fit-table-head">Build Up Area</th>
                  <th className="fit-table-head">Area by JE</th>
                  <th className="fit-table-head">Rate</th>
                  <th className="fit-table-head payment-head-amount">Amount</th>
                  <th className="fit-table-head payment-head-amount">info</th>
                  <th className="fit-table-head payment-head-amount">Remarks</th>
                </tr>
              </thead>
              <tbody>
                {mdmsPaymentHeads.map((item, index) => (
                  <tr key={item.key}>
                    <td>
                      <InputWrapper
                        type="checkbox"
                        name={`${item.key}.checked`}
                        defaultValue={Array.isArray(paymentHead) && paymentHead.some((result) => result.feeType === item.key) ? true : false}
                        control={control}
                        containerStyles={{ padding: "0px", margin: "0" }}
                      />
                    </td>
                    <td>{item.label}</td>
 
                    <td style={{ textAlign: "center" }}>
                      <InputWrapper
                        name={`${item.key}.plotBuildUpArea`}
                        hasLabel={false}
                        control={control}
                        placeholder="Enter area"
                        type="textInput"
                        defaultValue={item?.buildUpArea ? formData?.totalBuildUpArea : formData?.plotArea}
                        disabled
                        width="100%"
                        height={"22px"}
                        className="paymentHeadInput"
                        // disabled={isDA && !isJE}
                      />
                    </td>
                    <td>
                      <InputWrapper
                        name={`${item.key}.updatedAreaJE`}
                        hasLabel={false}
                        control={control}
                        placeholder="Enter area"
                        type="textInput"
                        defaultValue={item?.buildUpArea ? formData?.totalBuildUpArea : formData?.plotArea}
                        width="100%"
                        height={"22px"}
                        className="paymentHeadInput"
                        // disabled={isDA && !isJE}
                      />
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <InputWrapper
                        name={`${item.key}.rate`}
                        hasLabel={false}
                        height={"22px"}
                        control={control}
                        placeholder="Enter rate"
                        defaultValue={item.hasOwnProperty("rate") ? item.rate : calculateRate(formData?.plotArea, item.slabs)}
                        type="textInput"
                        width="100%"
                        className="paymentHeadInput"
                        // disabled={isDA && !isJE}
                      />
                    </td>
 
                    {/* Conditional Amount Cell */}
                    {Array.isArray(paymentHead) && paymentHead.length > 0 ? (
                      paymentHead.some((result) => result.feeType === item.key) ? (
                        paymentHead
                          .filter((result) => result.feeType === item.key)
                          .map((matchedResult) => (
                            <td className="payment-head-amount-td" key={matchedResult.feeType}>
                              ₹ {matchedResult.amount}
                            </td>
                          ))
                      ) : (
                        <td className="payment-head-amount" style={{ textAlign: "center" }}>
                          -
                        </td>
                      )
                    ) : (
                      <td className="payment-head-amount" style={{ textAlign: "center" }}>
                        -
                      </td>
                    )}
                   <td></td>
                    <td >
                           {/* <InputWrapper
                           name={`${item.key}.remarks`}
                          hasLabel={false}
                          control={control}
                          placeholder="Enter Remarks"
                          type="textInput"
                          width="12vw"
                          height={"22px"}
                          className="paymentHeadInput"
                        /> */}

                        <InputWrapper
                        name={`${item.key}.remarks`}
                        hasLabel={false}
                        control={control}
                        placeholder="Enter Remarks"
                        type="textInput"
                        defaultValue={item?.remarks ? item.remarks : ""}
                        width="100%"
                        height={"22px"}
                        className="paymentHeadInput"
                      />
                      </td>
                  </tr>
                ))}
                {additionalHeads.map((field, index) => {
                  const feeTypeValue = watch(`additionalHeads.${index}.feeType`); // Watch current feeType
                  const matchedPayment = paymentHead?.find((p) => p.feeType === feeTypeValue);
 
                  return (
                    <tr key={field.id}>
                      <td>
                        <IconButton color="error" aria-label="Delete" onClick={() => remove(index)}>
                          <DeleteIcon />
                        </IconButton>
                      </td>
 
                      <td>
                        <InputWrapper
                          type="textInput"
                          name={`additionalHeads.${index}.feeType`}
                          width="12vw"
                          control={control}
                          hasLabel={false}
                          height={"22px"}
                          className="paymentHeadInput"
                        />
                      </td>
 
                      <td>
                        <InputWrapper
                          name={`additionalHeads.${index}.plotBuildUpArea`}
                          hasLabel={false}
                          control={control}
                          placeholder="Enter area"
                          type="textInput"
                          width="12vw"
                          height={"22px"}
                          className="paymentHeadInput"
                        />
                      </td>
 
                      <td>
                        <InputWrapper
                          name={`additionalHeads.${index}.updatedAreaJE`}
                          hasLabel={false}
                          control={control}
                          placeholder="Enter area"
                          type="textInput"
                          width="12vw"
                          height={"22px"}
                          className="paymentHeadInput"
                        />
                      </td>
 
                      <td>
                        <InputWrapper
                          name={`additionalHeads.${index}.rate`}
                          hasLabel={false}
                          control={control}
                          placeholder="Enter rate"
                          type="textInput"
                          width="12vw"
                          height={"22px"}
                          className="paymentHeadInput"
                        />
                      </td>
 
                      <td style={{ textAlign: "center" }}>{matchedPayment ? `₹ ${matchedPayment.amount}` : "-"}</td>
                      <td >
                           <InputWrapper
                          name={`additionalHeads.${index}.remarks`}
                          hasLabel={false}
                          control={control}
                          placeholder="Enter Remarks"
                          type="textInput"
                          width="12vw"
                          height={"22px"}
                          className="paymentHeadInput"
                        />
                      </td>
                    </tr>
                  );
                })}
                {(taxHead?.[0]?.estimateAmount || formData?.taxHeadEstimates?.[1]?.estimateAmount) && (
                  <tr>
                    <td colSpan={5}>
                      <b style={{ fontSize: "16px" }}>Total Amount</b>
                    </td>
                    <td style={{ fontSize: "16px" }}>₹ {taxHead?.[0]?.estimateAmount || formData?.taxHeadEstimates?.[1]?.estimateAmount}</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </TableContainer>
        )}
        {!isFromDashboard && (
          <div className="footerContainer3">
            <div className="buttonWrapper">
              
              <Button
                variant="contained"
                color="success"
                size="medium"
                type="submit"
                disabled={disabled}
                style={{
                  backgroundColor: "#157CB3",
                  marginRight: "4px",
                  height: "28px",
                  color: "white",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                Calculate
              </Button>
              <Button
                variant="contained"
                color="success"
                size="medium"
                style={{
                  backgroundColor: "rgb(21, 124, 179)",
                  height: "28px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onClick={handleAddInput}
              >
                <span style={{ color: "white", display: "flex", alignItems: "center", gap: "4px" }}>
                  <AddIcon />
                  Add
                </span>
              </Button>
            </div>
          </div>
        )}
      
      </form>
) : (
  /* SHART 2: Agar openCompoundingModal TRUE ho jata hai, toh main form band ho jayega aur sirf yeh table dikhega */
  <CompoundingTable
    onCompoundingSubmit={handleCompoundingSubmit}
    compoundingFeeHeads={compoundingFeeHeads}
    compoundingData={compoundingHead}
    formData={formData}
    activeCategory={activeCategory}
    handleNoWorkflow={handleNoWorkflow}
    // Aap chahein to yahan ek 'Back' ya 'Cancel' button ke liye onClose pass kar sakte hain jo ise wapas false kar de
    onClose={() => setOpenCompoundingModal(false)}
  />
)}
    </React.Fragment>
  );
};

export default PaymentHead;
